module.exports = __webpack_public_path__ + "img/20190820133854766.371d3a42.png";